import React, { useRef, useState, useEffect } from 'react'
import Cart from '../Cart'
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import styles from './styles.less'
import HeaderNavItem from '../HeaderNavItem'
import { Link } from 'react-router-dom'
import Sidebar from '../Sidebar'
import { HEADLESS } from '../../../constants/headlessSetting'
import classnames from 'classnames'
import navItemStyles from '../HeaderNavItem/styles.less'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { menuTranslate } from 'helpers/routing'

export const Header = (props) => {
  const scrollMenuRef = useRef(null)
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(false)

  // Check if scrolling is possible and update arrow visibility
  const checkScroll = () => {
    const element = scrollMenuRef.current
    if (!element) return

    // Show left arrow if scrolled to the right
    setShowLeftArrow(element.scrollLeft > 0)

    // Show right arrow if there's more content to scroll to
    const maxScrollLeft = element.scrollWidth - element.clientWidth
    setShowRightArrow(element.scrollLeft < maxScrollLeft - 5) // 5px buffer
  }

  // Scroll handlers
  const scrollLeft = () => {
    scrollMenuRef.current.scrollBy({ left: -200, behavior: 'smooth' })
  }

  const scrollRight = () => {
    scrollMenuRef.current.scrollBy({ left: 200, behavior: 'smooth' })
  }

  // Set up event listeners
  useEffect(() => {
    const element = scrollMenuRef.current
    if (!element) return

    // Initial check
    checkScroll()

    // Check on scroll
    element.addEventListener('scroll', checkScroll)

    // Check on resize
    window.addEventListener('resize', checkScroll)

    // Clean up
    return () => {
      element.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (props.shop.id) {
    const { menu, shop, headless } = props
    let menuLeft = menu.left, menuRight = menu.right
    if (shop.locale === 'nb') {
      // NOTE: This is temp solution during peak season to minimize code change side effects
      //       mainly to facilitate SEO for nowergian's webshop
      // TODO: Accomodate i18n on url, slug and related
      menuLeft = menuTranslate(menu.left)
      menuRight = menuTranslate(menu.right)
    }

    const itemsLeft = menuLeft.map((item, index) => <HeaderNavItem key={index} item={item}/>)
    const itemsRight = menuRight.map((item, index) => <HeaderNavItem key={index} item={item}/>)

    let phoneNumber
    if (shop.phoneNumber)
      phoneNumber = <span><FontAwesomeIcon icon={faPhone} className={styles.phoneIcon} />{shop.phoneNumber}</span>

    // TODO: remove when phone number / top text is added to backend
    if (shop.webshopId === 25)
      phoneNumber = <span><FontAwesomeIcon icon={faPhone} className={styles.phoneIcon} />040-688-76-51</span>

    const navbar = (
        <div className={classnames([styles.fullWidth, 'background-dark', 'header-navbar'])}>
          <div className={classnames([styles.navbarContainer, "container"])}>
            <div className={classnames('nav-left', styles.navLeft)}>
              <div className={`${styles.menuContainer}`}>
                {showLeftArrow && (
                  <button
                    className={`${styles.navArrow} ${styles.navArrowLeft}`}
                    onClick={scrollLeft}
                    aria-label="Scroll left"
                  >
                    <FontAwesomeIcon className={styles.arrow} icon={faCaretLeft}/>
                  </button>
                )}

                <ul className={styles.scrollMenu} ref={scrollMenuRef}>
                  {itemsLeft}
                </ul>

                {showRightArrow && (
                  <button
                    className={`${styles.navArrow} ${styles.navArrowRight}`}
                    onClick={scrollRight}
                    aria-label="Scroll right"
                  >
                    <FontAwesomeIcon className={styles.arrow} icon={faCaretRight}/>
                  </button>
                )}
              </div>
            </div>
            <div className={classnames('nav-right', styles.navRight)}>
              {itemsRight}
              {headless === HEADLESS.SHOW_MENU_ONLY
                ? (
                    <li className={classnames('header-nav-item', navItemStyles.navItem)}>
                      <Cart className={styles.headlessCart} />
                    </li>
                  )
                : null
              }
            </div>
        </div>
      </div>
    )
    if (headless === HEADLESS.HIDE_ALL)
      return (
        <header className={classnames("container", "headless-header", styles.headlessHeader)}>
          <Row>
            <Col md="1" mdOffset="11">
              <Cart />
            </Col>
          </Row>
        </header>
      )
    else if (headless === HEADLESS.SHOW_MENU_ONLY)
      return (
        <header className={classnames('header', styles.header)}>
          {navbar}
        </header>
      )
    return (
      <header className={classnames('header', styles.header)}>
        <div className={`${styles.fullWidth} background-normal`}>
          <Row className={classnames('header-wrapper', styles.wrapperHeader)}>
            <Col md={2} xs={12} className={classnames('phone-number-container', styles.phoneNumber)}>{phoneNumber}</Col>
            <Col md={8} xs={12} className={classnames('header-container', styles.headerContainer)}>
              <Row className={styles.flexSpaceBetween}>
                <Col sm={12} className={classnames('logo-container', styles.logo)}>
                  <Link to="/" className={classnames('logo', styles.logotypeImage)}>
                    <img src={props.shop.style.logoUrl} className="logo-image" alt="/images/logotype.png"/>
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col md={2} xs={12} className={classnames('sidebar-container', styles.sidebarContainer, styles.pullRight)}>
              <Sidebar
                className={classnames('sidebar', styles.sidebar)}
                options={menuRight}
                extended={menuLeft}
              />
              <Cart />
            </Col>
          </Row>
        </div>
        {navbar}
      </header>
    )
  }
}

const mapStateToProps = state => {
  return {
    shop: state.shop,
    menu: state.menu,
    headless: state.shop.headless,
  }
}

export default connect(
  mapStateToProps
)(Header)
